import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

const PaymentStatus = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading"); // States: "loading", "success", "failed"
  const [accessLink, setAccessLink] = useState("");

  useEffect(() => {
    const payment_status = searchParams.get("payment_status");
    const payment_id = searchParams.get("payment_id");
    const payment_request_id = searchParams.get("payment_request_id");

    // 1️⃣ Check if the payment explicitly failed on Instamojo's end
    if (payment_status === "Failed") {
      setStatus("failed");
      return;
    }

    // 2️⃣ If successful, verify with the backend to get the exact link
    if (payment_id && payment_request_id) {
      verifyPayment(payment_id, payment_request_id);
    } else {
      setStatus("failed");
    }
  }, [searchParams]);

  const verifyPayment = async (paymentId, paymentRequestId) => {
    try {
      const response = await axios.post("https://fitnessfreak-hrc4.onrender.com/api/payment-success", {
        payment_id: paymentId,
        payment_request_id: paymentRequestId,
      });

      // 🟢 1. Tell Facebook the sale is FINAL and send the EXACT amount
      if (window.fbq) {
        window.fbq('track', 'Purchase', {
          value: response.data.amount, 
          currency: 'INR',
          content_type: 'product',
          content_name: 'Fitness Community Enrollment'
        });
        console.log(`✅ Meta Pixel: Purchase of ₹${response.data.amount} tracked!`);
      }

      setAccessLink(response.data.whatsappLink);
      setStatus("success");
    } catch (error) {
      console.error("Verification Error:", error);
      setStatus("failed");
    }
  };

  // --- UI Renders ---

  if (status === "loading") {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h2>Processing your payment... ⏳</h2>
      </div>
    );
  }

  // 🔴 Handle Failed Payment
  if (status === "failed") {
    return (
      <div style={{ textAlign: "center", marginTop: "50px", color: "red" }}>
        <h2>❌ Payment Failed</h2>
        <p>Something went wrong with your transaction. Please try again.</p>
        <button onClick={() => window.location.href = "/"}>Go Back</button>
      </div>
    );
  }

  // 🟢 Handle Successful Payment
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h2 style={{ color: "green" }}>✅ Payment Successful!</h2>
      <p>Click the link below to access your community:</p>
      
      {accessLink && (
        <a 
          href={accessLink} 
          target="_blank" 
          rel="noopener noreferrer"
          style={{
            display: "inline-block",
            marginTop: "20px",
            padding: "12px 24px",
            backgroundColor: "#007bff",
            color: "white",
            textDecoration: "none",
            borderRadius: "5px",
            fontWeight: "bold",
            fontSize: "18px"
          }}
        >
          Click Here to Continue
        </a>
      )}
    </div>
  );
};

export default PaymentStatus;
